import React, { useEffect, useState } from 'react';

import { ReactComponent as BrandIcon } from '../../assets/icons/sidebar/sidebar-device.svg';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';
import TabToggle from '../../shared-components/tab-toggle/TabToggle';

import Global from './components/Global';
import Local from './components/Local';

/**
 * Component for displaying brand management with Local and Global tabs
 * @returns {React.JSX.Element} Brand management component
 */
function BrandManagement() {
  const dispatch = useAppDispatch();
  const { totalResults: localTotal } = useAppSelector((state) => state.brand);
  const { totalResults: globalTotal } = useAppSelector((state) => state.globalBrand);
  const [selectedTab, setSelectedTab] = useState<string>('Local');

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: 'Brands',
        count: selectedTab === 'Local' ? localTotal : globalTotal,
        icon: <BrandIcon />,
      }),
    );
  }, [dispatch, localTotal, globalTotal, selectedTab]);

  return (
    <div className="brand-management-wrap">
      <div className="brand-management-container">
        <div className="table-content">
          <div className="tab-toggle-wrapper">
            <TabToggle
              tabs={[
                { label: 'Local', value: 'Local' },
                { label: 'Global', value: 'Global' },
              ]}
              defaultTab="Local"
              onChange={(tab) => setSelectedTab(tab)}
            />
          </div>

          {selectedTab === 'Local' ? <Local /> : <Global />}
        </div>
      </div>
    </div>
  );
}

export default BrandManagement;
